import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.8, delay, ease }}>
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.12 }) => (
  <motion.h1 className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 1.05, delay: delay + i * stagger, ease }}>{line}</motion.span>
      </span>
    ))}
  </motion.h1>
);

export const SectionHead = ({ eyebrow, title, sub, id }) => (
  <div className="max-w-2xl">
    <Reveal><p className="eyebrow mb-4" data-testid={id ? `${id}-eyebrow` : undefined}>{eyebrow}</p></Reveal>
    <Reveal delay={0.08}><h2 className="font-display text-balance text-3xl sm:text-4xl lg:text-5xl font-medium leading-[1.05] tracking-tight text-[#F8F6F0]">{title}</h2></Reveal>
    {sub && <Reveal delay={0.16}><p className="mt-4 text-sm sm:text-base text-[#AEB7C9] leading-relaxed max-w-lg">{sub}</p></Reveal>}
  </div>
);

export const Wrap = ({ children, className = "" }) => <div className={`mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 ${className}`}>{children}</div>;
